import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.mjs";
import app_45config_45global from "/app/middleware/app-config.global.ts";
export const globalMiddleware = [
  validate,
  app_45config_45global
]
export const namedMiddleware = {}